<template>
  <div class="certificate-box">
    <!-- ['010', '011'] -->
    <div
      class="tips-box"
      v-if="!(pictureTypes.includes('010') || pictureTypes.includes('011')) && (autoDeal && !hasUnderGround)"
    >
      此单必须用相机拍照，不支持从相册上传，或联系调度从后台上传
    </div>
    <div
      class="card-box"
      v-for="group in imageList"
      :key="group.primaryCode"
    >
      <div class="card-title">
        {{ group.primaryName }}
      </div>
      <div class="card-content">
        <div
          v-for="(item, index) in group.secondary"
          class="img-box"
          :key="index"
        >
          <div class="img-title">
            <span>{{ item.typeName }}</span>
            <span
              class="color-red"
              v-if="item.requiredNum === 1"
            >(必传)</span>
          </div>
          <div
            class="img-tips"
            v-if="item.promptText"
          >
            {{ item.promptText }}
          </div>
          <div
            class="img-tips"
            v-if="taskDetail.isPaicXiaMen && ['004025'].includes(item.categoryCode)"
          >
            (需故障码，无故障码报备)
          </div>
          <div
            class="img-tips"
            v-else-if="taskDetail.isPaicOrder === 1 && ['004025'].includes(item.categoryCode)"
          >
            (仪表盘要亮起，不亮要报备)
          </div>
          <div
            class="img-tips"
            v-if="taskDetail.isPaicOrder === 1 && ['003012'].includes(item.categoryCode)"
          >
            (必须体现平安LOGO车贴)
          </div>
          <div
            class="img-tips"
            v-if="showBlackScreensTipsCurrent && taskDetail.channelCompanyNo === 'HAIC' && ['004025'].includes(item.categoryCode)"
          >
            (仪表盘必须体现通电或插钥匙)
          </div>
          <div
            class="img-tips"
            v-if="taskDetail.isPaicOrder === 1 && ['004033'].includes(item.categoryCode)"
          >
            (检测仪需要全部入镜)
          </div>
          <div
            class="img-tips"
            v-if="taskDetail.channelCompanyNo === 'TKIC' && ['004011', '006011'].includes(item.categoryCode)"
          >
            (同时拍到拖车车牌和客户车牌)
          </div>
          <div
            class="img-tips"
            v-if="taskDetail.channelCompanyNo === 'GPIC' && ['003011', '001010'].includes(item.categoryCode)"
          >
            (车牌号务必拍摄清楚！)
          </div>
          <div
            class="img-tips"
            v-if="isPiccShenzhenVehicleHeadDiagonal(item)"
          >
            (要体现劳保手套和人保LOGO)
          </div>
          <div
            class="img-tips"
            v-if="isPiccGuangdongVehicleHeadDiagonal(item)"
          >
            (要体现劳保手套)
          </div>
          <div
            class="img-content"
            v-if="item.mediaList"
          >
            <div
              class="img-upload"
              v-if="!['010', '011'].includes(item.primaryCode) && (autoDeal && !hasUnderGround)"
            >
              <van-uploader
                v-model="item.mediaList"
                accept="image/*"
                :max-count="item.maxNum"
                :before-read="beforeRead"
                :after-read="({file}) => {afterRead(file, item)}"
                :before-delete="beforeDelete"
                @delete="delMediaById"
                :show-upload="!disabled"
                :deletable="!disabled"
                capture="camera"
              >
                <div
                  v-if="!disabled"
                  class="img-upload-btn"
                  :style="{'background-image': `url(${item.backgroundUrl})`}"
                />
              </van-uploader>
            </div>
            <div
              class="img-upload"
              v-else
            >
              <van-uploader
                v-model="item.mediaList"
                accept=".jpg, .png, .jpeg, .mp3, .mp4, .m4a, .JPG, .PNG, .JPEG, .MP3, .MP4, .M4A"
                :max-count="item.maxNum"
                :before-read="beforeRead"
                :after-read="({file}) => {afterRead(file, item)}"
                :before-delete="beforeDelete"
                @delete="delMediaById"
                :show-upload="!disabled"
                :deletable="!disabled"
              >
                <div
                  v-if="!disabled"
                  class="img-upload-btn"
                  :style="{'background-image': `url(${item.backgroundUrl})`}"
                />
              </van-uploader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />
  </div>
</template>

<script>
import {
  mediaTemplate,
  getMediaDetail,
  saveMedia,
  delMediaById
} from '@/common/apiGeneral.js';
import {
  getTaskDetail
} from '@/common/apiPaic.js';
import { upload, getFileName } from '@/utils/ourOss';
import ConfirmDialog from '@/components/confirmDialog.vue';
import Compressor from 'compressorjs';
import MobileDetect from 'mobile-detect';
import { judgeBrand, arrModal } from '../common/mobileInfo';
import dayjs from 'dayjs';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import { cloneDeep } from 'lodash';
export default {
  name: 'GeneralOrderCertificate',
  mixins: [getCurrentPositionMixin],
  components: {
    ConfirmDialog
  },
  props: {
    photoParams: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useIncomingIsBlackScreens: {
      type: Boolean,
      default: false
    },
    showBlackScreensTips: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderNo: '',
      taskNo: '',
      useTraceCar: '',
      pictureTypes: [],
      isFromPre: false,
      hasUnderGroundFromPre: false,
      imageList: [],
      unCompletedTxt: [],
      taskDetail: {}
    };
  },
  computed: {
    // 触发过系统自动处理时间的订单，APP、SPS、H5都不在允许使用上传凭证，只能支持APP、H5拍照，点击上传时报错“此单必须用APP拍照，不支持从相册上传”
    autoDeal() {
      return this.taskDetail?.dealPaicCallbackArriveTime === 1 || false;
    },
    // 是否地库牵引数量大于等于1
    hasUnderGround() {
      if (this.isFromPre) {
        return this.hasUnderGroundFromPre;
      } else {
        const {
          extraProduct
        } = this.taskDetail;
        const hasUnderGround = (extraProduct || []).some(item => item.desc === '00002' && item.value >= 1);

        return hasUnderGround;
      }
    },
    showBlackScreensTipsCurrent() {
      return this.useIncomingIsBlackScreens
        ? this.showBlackScreensTips
        : this.taskDetail.blackScreen === 1;
    }
  },
  watch: {
    'photoParams': {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.photoParams) {
        const {
          orderNo,
          taskNo,
          useTraceCar,
          pictureTypes,
          hasUnderGround
        } = this.photoParams;
        this.orderNo = orderNo;
        this.taskNo = taskNo;
        this.useTraceCar = useTraceCar;
        this.pictureTypes = pictureTypes;
        this.isFromPre = typeof hasUnderGround === 'boolean';
        this.hasUnderGroundFromPre = hasUnderGround;
        this.getTaskDetail();
        this.mediaTemplate();
      }
    },
    getMobileName() {
      // const userAgent = 'Mozilla/5.0 (Linux; Android 12; HarmonyOS; ABR-AL00; HMSCore 6.9.6.302) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.88 HuaweiBrowser/13.0.4.302 Mobile Safari/537.36';
      // const userAgent = 'Mozilla/5.0 (Linux; U; Android 10; zh-cn; M2002J9E Build/QKQ1.191222.002) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/100.0.4896.127 Mobile Safari/537.36 XiaoMi/MiuiBrowser/17.5.120328 swan-mibrowser';
      // const userAgent = 'Mozilla/5.0 (Linux; Android 13; M2012K11AC Build/TKQ1.220829.002; ) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/104.0.5112.97 Mobile Safari/537.36 BingSapphire/23.8.2110003536';
      const userAgent = window.navigator.userAgent;
      console.log(userAgent, '获取userAgent信息');

      const md = new MobileDetect(userAgent);
      let os = md.os(); // 获取系统
      let model = md.mobile();
      let val;
      if (os === 'iOS') {
        // ios系统的处理
        // console.log(md.mobile(), os, '获取系统', os === 'iOS');
        if (model === 'iPhone') {
          const iphoneArr = [
            ['430,932,3', 'A15', 'iPhone 14 Pro Max'],
            ['393,852,3', 'A15', 'iPhone 14 Pro'],
            ['375,812,3', 'A15', 'iPhone 13(12) min'],
            ['428,926,3', 'A14', 'iPhone 14(12/13) Plus'],
            ['390,844,3', 'A14', 'iPhone 14(12/13)'],
            ['414,896,3', 'A13', 'iPhone 11 Pro Max(Xs Max)'],
            ['375,812,3', 'A13', 'iPhone 11 Pro(X/Xs)'],
            ['414,896,2', 'A13', 'iPhone 11(XR)'],
            ['414,736,3', 'A12', 'iPhone 8(7/6s) Plus'],
            ['375,667,2', 'A11', 'iPhone 8(7/6)'],
            ['320,568,2', 'A11', 'iPhone 5(s/se)'],
            ['320,480,2', 'A10', 'iPhone 4(s)']
          ];

          // 获取GPU信息
          const canvas = document.createElement('canvas');
          const gl = canvas.getContext('experimental-webgl');
          const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');

          const iphoneGPU = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
          const width = window.screen.width;
          const height = window.screen.height;
          const devicePixelRatio = window.devicePixelRatio;
          console.log(width, height, devicePixelRatio);

          const baseInfo = width + ',' + height + ',' + devicePixelRatio;
          iphoneArr.some((item) => {
            if (item[0] === baseInfo) {
              model = item[2];
              console.log('iphoneGPU', iphoneGPU === item[1]);
            }
          });
          os = +md.version('iPhone');
          // console.log(`${md.mobile()} IOS${os}`);
          // console.log(model, '鸡鸡', userAgent.toLowerCase());
          val = model;
        } else {
          model = 'iPad';
        }
      } else if (os === 'AndroidOS') {
        // Android系统的处理
        if (!model || model === 'UnknownPhone' || model === 'UnknownMobile') {
          let j;
          const sss = userAgent.split(';');
          for (let i = 0; i < sss.length; i++) {
            if (sss[i].indexOf('Build/') > 0) {
              j = i;
              break;
            }
          }
          if (j > -1) {
            model = sss[j].substring(0, sss[j].indexOf('Build/'));
            val = model;
          } else {
            if (!val) {
              // 处理华为
              if (userAgent.split(')')[0].includes('HMSCore')) {
                const HMS = userAgent.split(')')[0].split('HMSCore')[0].split(';');
                model = HMS[HMS.length - 2];
                val = 'Huawei' + model;
              }
            }
          }

          arrModal.map((item) => {
            if (item.type === judgeBrand(userAgent.toLowerCase())) {
              item.modelNumber.map((vm) => {
                if (vm.lable === model.trim()) {
                  val = vm.value;
                }
              });
            }
          });
        } else {
          val = model;
        }
      }

      // console.log(val);
      val = val || '其他型号手机';
      console.log('我model是', val);
      return val;
    },
    isVehicleHeadDiagonal(item) {
      return item.categoryCode === '001010';
    },
    isPiccShenzhenVehicleHeadDiagonal(item) {
      return this.taskDetail.channelCompanyNo === 'PICC' &&
        this.taskDetail.channelCompanySubNo === '44030000' &&
        this.isVehicleHeadDiagonal(item);
    },
    isPiccGuangdongVehicleHeadDiagonal(item) {
      return this.taskDetail.channelCompanyNo === 'PICC' &&
        this.taskDetail.channelCompanySubNo === '44000000' &&
        this.isVehicleHeadDiagonal(item);
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async mediaTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await mediaTemplate({
          orderNo: this.orderNo,
          useTraceCar: this.useTraceCar,
          pictureTypes: this.pictureTypes,
          requestType: this.pictureTypes.length ? 2 : 1
        });
        if (data) {
          this.imageList = data;
          this.getMediaDetail();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMediaDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getMediaDetail({
          orderNo: this.orderNo
        });
        console.log(data);
        if (data) {
          this.unCompletedTxt = [];
          this.imageList.forEach(group => {
            group.secondary.forEach(item => {
              const mediaList = data.filter(media => {
                if (media.categoryCode === item.categoryCode) {
                  media.isImage = media.fileType === 'image';
                  return media;
                }
              });
              if (!(mediaList && mediaList.length) && item.requiredNum === 1) {
                this.unCompletedTxt.push(item.typeName);
              }
              this.$set(item, 'primaryCode', group.primaryCode);
              this.$set(item, 'mediaList', mediaList);
            });
          });
          console.log('this.imageList: ', this.imageList);
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async beforeRead(file) {
      return new Promise((resolve, reject) => {
        // 设置允许上传图片格式为jpg
        const FileExt = file.name.replace(/.+\./, '');
        const isLtFileType = ['jpg', 'png', 'jpeg', 'mp3', 'mp4', 'm4a'].includes(FileExt.toLowerCase());
        if (!isLtFileType) {
          this.$toast('上传文件只能是jpg, png, jpeg, mp3, mp4, m4a格式');
          reject();
          return false;
        }
        const isLtFileSize = file.size / 1024 / 1024 < 10;

        if (!isLtFileSize) {
          this.$toast('上传文件大小不能超过 10MB!');
          reject();
          return false;
        }

        const isLtFileName = getFileName(file.name).length <= 50;
        // 限制文件名
        if (!isLtFileName) {
          this.$toast('文件名不能超过50个字符');
          reject();
          return false;
        }
        if (file.type.includes('image')) {
          // 判定经纬度
          if (!this.currentPosition) {
            this.$toast('当前位置获取失败，请确认是否打开位置权限！');
            return false;
          }
        }
        resolve(file);
      });
    },
    doCompressor(file, dayjsDate) {
      return new Promise((resolve, reject) => {
        // 将图片压缩到1M以内
        const quality = 0.8;
        const compressor = new Compressor(file, {
          strict: false,
          quality,
          maxWidth: 2160,
          minWidth: 1080,
          drew: (context, canvas) => {
            const fillWidth = canvas.width * 3 / 4;
            let fontBit = 30;
            if (canvas.width > 1080) {
              fontBit = fontBit * canvas.width / 1080;
            }
            const wordLength = Math.ceil(fillWidth / fontBit);
            const lineHeight = 1.5;
            const fillX = canvas.width - fontBit;
            context.font = `${fontBit}px Roboto, PingFang`;
            context.fillStyle = 'red';
            context.textAlign = 'right';
            context.textBaseline = 'Middle';
            context.fillText(`救援师傅:${this.taskDetail.workerName}`, fillX, fontBit * lineHeight); // 水印在画布的位置x，y轴
            context.fillText(`(${this.getMobileName()}相机)${dayjsDate.format('YYYY-MM-DD HH:mm:ss')}`, fillX, fontBit * lineHeight * 2);
            // 计算地址的长度，超过一屏就换行
            const addressWordLength = this.currentPosition.formattedAddress.length;
            const lines = Math.ceil(addressWordLength / wordLength);
            if (lines > 1) {
              for (let index = 0; index < lines; index++) {
                const address = this.currentPosition.formattedAddress.slice(wordLength * index, wordLength * (index + 1));
                context.fillText(address, fillX, fontBit * lineHeight * (3 + index));
              }
            } else {
              context.fillText(this.currentPosition.formattedAddress, fillX, fontBit * lineHeight * 3);
            }
            context.fillText(`经度:${this.currentPosition.longitude} 纬度:${this.currentPosition.latitude}`, fillX, fontBit * lineHeight * (3 + lines));
          },
          success: (result) => {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
          }
        });
        console.log(compressor);
      });
    },
    // 自定义上传
    async afterRead(file, { categoryCode, isWorkingSpacePic, primaryCode }) {
      console.log(file.name, 'afterRead file.name');
      console.log(file, 'afterRead file');
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      let realFile = cloneDeep(file);
      let virtualFile = cloneDeep(file);
      let realPicFileId = '';
      let waterMarkTime = '';
      let resArr = [];
      const today = dayjs();
      // compressorjs 默认开启 checkOrientation 选项
      // 会将图片修正为正确方向
      if (file.type.includes('image')) {
        realFile = await this.doCompressor(file, today);
        // 触发过系统自动处理时间的订单
        if (this.autoDeal && isWorkingSpacePic) {
          const arriveTime = dayjs(this.taskDetail.paicCallbackArriveTime);
          console.log('today: ', today.unix());
          console.log('arriveTime: ', arriveTime.unix());
          const diff = today.diff(arriveTime, 'minute', true);
          console.log('diff: ', diff);

          // 到达时间大于5分钟 && 到达时间未超过1小时 将生成两张图片
          if (diff > 5 && diff <= 60) {
            // 获取缓存的虚拟时间
            const localWaterMarkTime = localStorage.getItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo);
            if (localWaterMarkTime) {
              // 5-15s
              const randomTime = Math.random() * 10 + 5;
              waterMarkTime = 1 * localWaterMarkTime + 1 * randomTime;
            } else {
              // 取1分钟至5.5分钟内随机数
              const randomTime = Math.random() * 4.5 * 60 + 60;
              waterMarkTime = 1 * arriveTime.unix() + 1 * randomTime;
            }
            // 压缩
            virtualFile = await this.doCompressor(file, dayjs.unix(waterMarkTime));
            console.log('waterMarkTime: ', waterMarkTime);
            console.log('realFile: ', realFile);
            console.log('virtualFile: ', virtualFile);
            // return;
            resArr = await Promise.all([upload(realFile), upload(virtualFile)]);
            const isSuccess = resArr.every(res => (String(res.data.code) === '0'));
            if (!isSuccess) {
              this.$toast('上传失败');
              return;
            } else {
              const res = resArr[0];
              const data = res.data.data;
              realPicFileId = data.picId;
              // 缓存虚拟时间
              localStorage.setItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo, waterMarkTime);
            }
          } else {
            const res = await upload(realFile);
            if (!(String(res.data.code) === '0')) {
              this.$toast(res.data.message);
              return;
            }
            resArr = [res];
          }
        } else {
          const res = await upload(realFile);
          if (!(String(res.data.code) === '0')) {
            this.$toast(res.data.message);
            return;
          }
          resArr = [res];
        }
      } else {
        const res = await upload(file);
        if (!(String(res.data.code) === '0')) {
          this.$toast(res.data.message);
          return;
        }
        resArr = [res];
      }

      const medias = resArr.map((res, index) => {
        const data = res.data.data;
        let fileType = 'image';
        const arr = file.name.split('.');
        const suffix = arr[arr.length - 1].toLowerCase();
        if (['mp4'].includes(suffix)) {
          fileType = 'video';
        }
        if (['mp3', 'm4a'].includes(suffix)) {
          fileType = 'audio';
        }
        let media = {

          'pictureType': primaryCode,
          'categoryCode': categoryCode,
          'fileName': file.name,
          'fileType': fileType,
          'orderNo': this.orderNo,
          'uploadFrom': 'H5上传',
          'fileId': res.type === 'myFile' ? data.fileId : data.picId
        };
        // 自定义水印，上传地址经纬度信息
        const { longitude, latitude, formattedAddress } = this.currentPosition;
        media.takeLongitude = longitude;
        media.takeLatitude = latitude;
        media.takeLocaltion = formattedAddress;
        media.albumNoMarkUpload = true;
        // 上传经纬度和水印时间
        media.watermarkLongitude = longitude;
        media.watermarkLatitude = latitude;
        media.watermarkAddress = formattedAddress;
        media.watermarkTime = today.format('YYYY-MM-DD HH:mm:ss');
        if (index === 1) {
          media = {
            ...media,
            'realPicFileId': realPicFileId,
            'virtualMarkTime': dayjs.unix(waterMarkTime).format('YYYY-MM-DD HH:mm:ss'),
            'watermarkTime': dayjs.unix(waterMarkTime).format('YYYY-MM-DD HH:mm:ss')
          };
        }
        return media;
      });

      console.log('medias: ', medias);

      const uploadParams = {
        medias
      };
      try {
        await saveMedia(uploadParams);
        this.$toast('上传成功');
        this.mediaTemplate();
        this.$emit('uploadCompleted');
      } catch (error) {
        console.log(error);
      }
      this.$toast.clear();
    },
    // 备份
    async afterRead2(file, { categoryCode, isWorkingSpacePic, primaryCode }) {
      console.log(file.name, 'afterRead file.name');
      console.log(file, 'afterRead file');
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      let realFile = cloneDeep(file);
      let virtualFile = cloneDeep(file);
      let realPicFileId = '';
      let waterMarkTime = '';
      let resArr = [];
      // compressorjs 默认开启 checkOrientation 选项
      // 会将图片修正为正确方向
      if (file.type.includes('image')) {
        realFile = await this.doCompressor(file, dayjs());
        if (isWorkingSpacePic) {
          // 大于5分钟将生成两张图片
          const today = dayjs();
          const arriveTime = dayjs(this.taskDetail.latestArriveTime);
          console.log('today: ', today.unix());
          console.log('arriveTime: ', arriveTime.unix());
          const diff = today.diff(arriveTime, 'minute', true);
          console.log('diff: ', diff);

          const orderCreateTime = dayjs(this.taskDetail.orderCreateTime);
          const diff2 = today.diff(orderCreateTime, 'minute', true);

          // 到达时间大于5分钟将生成两张图片 && 非预约单 && 下单时间未超过1小时
          if (diff > 5 && diff2 <= 60 && this.taskDetail.appointmentTime === '实时订单') {
            // 获取缓存的虚拟时间
            const localWaterMarkTime = localStorage.getItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo);
            if (localWaterMarkTime) {
              // 5-15s
              const randomTime = Math.random() * 10 + 5;
              waterMarkTime = 1 * localWaterMarkTime + 1 * randomTime;
            } else {
              // 取1分钟至5.5分钟内随机数
              const randomTime = Math.random() * 4.5 * 60 + 60;
              waterMarkTime = 1 * arriveTime.unix() + 1 * randomTime;
            }
            // 压缩
            virtualFile = await this.doCompressor(file, dayjs.unix(waterMarkTime));
            console.log('waterMarkTime: ', waterMarkTime);
            console.log('realFile: ', realFile);
            console.log('virtualFile: ', virtualFile);
            // return;
            resArr = await Promise.all([upload(realFile), upload(virtualFile)]);
            const isSuccess = resArr.every(res => (String(res.data.code) === '0'));
            if (!isSuccess) {
              this.$toast('上传失败');
              return;
            } else {
              const res = resArr[0];
              const data = res.data.data;
              realPicFileId = data.picId;
              // 缓存虚拟时间
              localStorage.setItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo, waterMarkTime);
            }
          } else {
            const res = await upload(realFile);
            if (!(String(res.data.code) === '0')) {
              this.$toast(res.data.message);
              return;
            }
            resArr = [res];
          }
        } else {
          const res = await upload(realFile);
          if (!(String(res.data.code) === '0')) {
            this.$toast(res.data.message);
            return;
          }
          resArr = [res];
        }
      } else {
        const res = await upload(file);
        if (!(String(res.data.code) === '0')) {
          this.$toast(res.data.message);
          return;
        }
        resArr = [res];
      }

      const medias = resArr.map((res, index) => {
        const data = res.data.data;
        let fileType = 'image';
        const arr = file.name.split('.');
        const suffix = arr[arr.length - 1].toLowerCase();
        if (['mp4'].includes(suffix)) {
          fileType = 'video';
        }
        if (['mp3', 'm4a'].includes(suffix)) {
          fileType = 'audio';
        }
        let media = {

          'pictureType': primaryCode,
          'categoryCode': categoryCode,
          'fileName': file.name,
          'fileType': fileType,
          'orderNo': this.orderNo,
          'uploadFrom': 'H5上传',
          'fileId': res.type === 'myFile' ? data.fileId : data.picId
        };
        // 自定义水印，上传地址经纬度信息
        const { longitude, latitude, formattedAddress } = this.currentPosition;
        media.takeLongitude = longitude;
        media.takeLatitude = latitude;
        media.takeLocaltion = formattedAddress;
        media.albumNoMarkUpload = true;
        if (index === 1) {
          media = {
            ...media,
            'realPicFileId': realPicFileId,
            'virtualMarkTime': dayjs.unix(waterMarkTime).format('YYYY-MM-DD HH:mm:ss')
          };
        }
        return media;
      });

      console.log('medias: ', medias);

      const uploadParams = {
        medias
      };
      try {
        await saveMedia(uploadParams);
        this.$toast('上传成功');
        this.mediaTemplate();
        this.$emit('uploadCompleted');
      } catch (error) {
        console.log(error);
      }
      this.$toast.clear();
    },
    // 自定义上传
    async beforeDelete(file) {
      return new Promise((resolve, reject) => {
        const confirmText = '确定删除该图片吗?';
        this.$refs.confirmDialog.open({
          confirmText,
          confirmCallback: () => {
            console.log('confirmCallback');
            resolve(file);
          },
          cancelCallback: () => {
            reject();
          }
        });
      });
    },
    async delMediaById(file, detail, noLoading) {
      console.log('delMediaById: ', { file, noLoading });
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await delMediaById({
          orderNo: this.orderNo,
          mediaId: file.id
        });
        this.getMediaDetail();
        if (!noLoading) {
          this.$toast.clear();
        }
        this.$toast('删除成功');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.certificate-box{
  .tips-box {
    margin: 0 0 16px 0;
    padding: 12px 16px;

    background: #FFFAF0;
    border-radius: 8px;

    color: #FF8A59;

    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }
  .card-box{
    border-radius: 8px;
    background: #FFFFFF;

    & + .card-box{
      margin-top: 0;
    }

    .card-title{
      position: relative;

      padding: 0 0 16px 12px;

      letter-spacing: 0;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      &::before{
        position: absolute;
        left: 0;

        width: 4px;
        height: 16px;

        content: ' ';

        background: #D1D1D1;
      }
    }

    .card-content{
      .img-box{
        & + .img-box{
          margin-top: 24px;
        }
        .img-title{
          color: #383838;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;

          .color-red{
            color: #FF8A59;
          }
        }
        .img-tips {
          margin-top: 4px;

          color: red;

          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: 400;
        }
        .img-content{
          display: flex;
          align-items: flex-end;

          .img-upload{
            margin-top: 10px;

            .img-upload-btn{
              position: relative;

              display: -webkit-box;
              display: -webkit-flex;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;

              box-sizing: border-box;
              width: 80px;
              height: 80px;
              margin: 0 8px 8px 0;

              background-color: #f7f8fa;
              background-repeat:no-repeat;
              background-position: center center;
              background-size: auto 100%;

              .van-icon {
                color: #dcdee0;

                font-size: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
